import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';

const StyledIconWrapperDiv = styled.div`
  grid-area: icon;
`;
const StyledIconDiv = styled.div`
  border-radius: 10px;
  background: ${(p) => p.theme.palette.blue.shade20};
  color: ${(p) => p.theme.palette.blue.shade40};
  display: block;
  height: 40px;
  width: 40px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  flex-basis: 20px;
`;

interface SettingsHomeShortcutIconProps {
  icon: IconName;
}
export const SettingsHomeShortcutIcon: FC<SettingsHomeShortcutIconProps> = (props) => {
  const theme = useUserTheme();

  return (
    <StyledIconWrapperDiv>
      <StyledIconDiv>
        <StyledIcon name={props.icon} color={theme.palette.blue.shade40} />
      </StyledIconDiv>
    </StyledIconWrapperDiv>
  );
};
